import { createSlice, isFulfilled } from '@reduxjs/toolkit';
import { startListening } from '../listenerMiddleware.js';

const routeSlice = createSlice({
    name: 'route',
    initialState: {
        path: null,
        back: false,
    },
    reducers: {
        navigate: (state, action) => {
            state.path = action.payload;
            state.back = false;
        },
        // Returns to the view the user came from (see SdbCompositionEditor._goto).
        // The payload is the fallback path, used when there is no previous view,
        // e.g. after opening a deep link.
        navigateBack: (state, action) => {
            state.path = action.payload;
            state.back = true;
        },
        navigated: (state) => {
            state.path = null;
            state.back = false;
        },
    },
});

export const { navigate, navigateBack, navigated } = routeSlice.actions;

export default routeSlice.reducer;

startListening({
    matcher: isFulfilled,
    effect: async (action, { dispatch }) => {
        const { payload } = action;

        let path = null;
        switch (action.type) {
            case 'draft/create/fulfilled':
            case 'draft/duplicate/fulfilled':
                path = `draft/${payload.id}`;
                break;
            case 'lti/create/fulfilled':
                path = `ltiitem/${payload.targetId}`;
                break;
            case 'ltiAdvantage/create/fulfilled':
                path = `ltiadvantageitem/${payload.targetId}`;
                break;
        }

        if (path) {
            dispatch(navigate(path)); // navigate expects the path string (see SdbCompositionEditor.path)
        }
    },
});
